import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { CustomHeaderComponent } from "@Components/CustomHeader/CustomHeaderComponent"
import Knowledge from "@Screens/Knowledge/Knowledge"
import UserSettingStack from "@Navigation/UserSettingStack/UserSettingStack"
import Savoirs from "@Screens/Knowledge/Savoirs/Savoirs"
import SavoirFaire from "@Screens/Knowledge/SavoirFaire/SavoirFaire"
import SavoirEtre from "@Screens/Knowledge/SavoirEtre/SavoirEtre"
import SavoirsTopTabStack from "@Navigation/TopTabBarStack/SavoirsTopTabStack/SavoirsTopTabStack"
import VideosDetails from "@Components/CustomVideoItem/VideosDetails/VideosDetails"
import SavoirEtreTopTabStack from "@Navigation/TopTabBarStack/SavoirEtreTopTabStack/SavoirEtreTopTabStack"
import SavoirFaireTopTabStack from "@Navigation/TopTabBarStack/SavoirFaireTopTabStack/SavoirFaireTopTabStack"
import TopicContent from "@Screens/Knowledge/TopicContent/TopicContent"
import { EvaluationQuizz } from "@Screens/Knowledge/Savoirs/Evaluation/EvaluationQuizz/EvaluationQuizz"
import Forum from "@Screens/Knowledge/SavoirEtre/Forum/Forum"
import ForumTopic from "@Screens/Knowledge/SavoirEtre/Forum/ForumTopic/ForumTopic"
import WorkshopDetails from "@Screens/Knowledge/SavoirFaire/Ateliers/WorkshopDetails/WorkshopDetails"
import { AppointmentVisioContent } from "@Screens/FollowUp/Appointment/AppointmentVisioContent"

const KnowledgeStackNavigator = createNativeStackNavigator()

const KnowledgeStack = () => (
    <KnowledgeStackNavigator.Navigator
        screenOptions={{
            headerShown: true,
            header: (props) => <CustomHeaderComponent {...props} />
        }}
        initialRouteName="KnowledgeScreen"
    >
        <KnowledgeStackNavigator.Screen name="KnowledgeScreen" component={Knowledge} />
        <KnowledgeStackNavigator.Screen name="UserSettings" component={UserSettingStack} />
        <KnowledgeStackNavigator.Screen name="VideosDetails" component={VideosDetails} />
        <KnowledgeStackNavigator.Screen name="Savoirs" component={Savoirs} />
        <KnowledgeStackNavigator.Screen name="SavoirFaire" component={SavoirFaire} />
        <KnowledgeStackNavigator.Screen name="SavoirEtre" component={SavoirEtre} />
        <KnowledgeStackNavigator.Screen name="SavoirsTopTabStack" component={SavoirsTopTabStack} />
        <KnowledgeStackNavigator.Screen name="SavoirFaireTopTabStack" component={SavoirFaireTopTabStack} />
        <KnowledgeStackNavigator.Screen name="SavoirEtreTopTabStack" component={SavoirEtreTopTabStack} />
        <KnowledgeStackNavigator.Screen name="ForumScreen" component={Forum} />
        <KnowledgeStackNavigator.Screen name="ForumTopic" component={ForumTopic} />
        <KnowledgeStackNavigator.Screen name="TopicContent" component={TopicContent} />
        <KnowledgeStackNavigator.Screen name="EvaluationQuizz" component={EvaluationQuizz} />
        <KnowledgeStackNavigator.Screen name="WorkshopDetails" component={WorkshopDetails} />
        <KnowledgeStackNavigator.Screen name="AppointmentVisioContent" component={AppointmentVisioContent} />
    </KnowledgeStackNavigator.Navigator>
)

export default KnowledgeStack
